module.exports = aws_amplify_auth;